import React from 'react';

import "./Bpopup_list.css"

function BpopupList(props) {
    return (
        <div className='brand_popup'>
            <div className='Bpopup_img'>
                <div className='Bpopup_imgbox'>
                    <img src='/img/nav_1.png' />
                    <span className='Bpopup_text'>HAZZYS</span>
                </div>
                <div className='Bpopup_imgbox'>
                    <img src='/img/nav_2.png' />
                    <span className='Bpopup_text'>DAKS</span>
                </div>
                <div className='Bpopup_imgbox'>
                    <img src='/img/nav_3.png' />
                    <span className='Bpopup_text'>JILLSTUART<br />NEW YORK</span>
                </div>
                <div className='Bpopup_imgbox'>
                    <img src='/img/nav_4.png' />
                    <span className='Bpopup_text'>VANESSABRUNO</span>
                </div>
            </div>

            <div className='Bpopup_list'>
                    <ul className='Bpopup_listBox'>
                        <li>루이비통</li>
                        <li>마에스트로</li>
                        <li>몽블랑</li>
                        <li>몽클레어</li>
                        <li>바네사브루노</li>
                        <li>바쉬</li>
                        <li>발렌시아가</li>
                        <li>버버리</li>
                        <li>버켄스탁</li>
                        <li>보테가 베네타</li>
                        <li>봉통</li>
                        <li>불리</li>
                    </ul>
                    <ul className='Bpopup_listBox'>
                        <li>블랙야크</li>
                        <li>빈스</li>
                        <li>생로랑</li>
                        <li>설화수</li>
                        <li>쉬즈미스</li>
                        <li>스텔라 매카트니</li>
                        <li>아디다스</li>
                        <li>아떼뷰티</li>
                        <li>아틀리에먼로</li>
                        <li>알레그리</li>
                        <li>앳코너</li>
                        <li>엠에스지엠</li>
                    </ul>
                    <ul className='Bpopup_listBox'>
                        <li>예작</li>
                        <li>오아이오아이</li>
                        <li>오피신제네랄</li>
                        <li>이자벨마랑</li>
                        <li>일꼬르소</li>
                        <li>조셉</li>
                        <li>질 바이 질스튜어트</li>
                        <li>질스튜어트 뉴욕</li>
                        <li>질스튜어트스포츠</li>
                        <li>챔피온</li>
                        <li>콜한</li>
                        <li>키르시</li>
                    </ul>
                    <ul className='Bpopup_listBox'>
                        <li>가스트로박</li>
                        <li>골든구스</li>
                        <li>구찌</li>
                        <li>까르뱅</li>
                        <li>나이키</li>
                        <li>넘버21</li>
                        <li>닥스</li>
                        <li>리복</li>
                        <li>듀얼릿</li>
                        <li>라움</li>
                        <li>라움 보야지</li>
                        <li>레오나드</li>
                    </ul>
                    <ul className='Bpopup_listBox'>
                        <li>탐스</li>
                        <li>티엔지티</li>
                        <li>티피코시</li>
                        <li>파리게이츠</li>
                        <li>판도라</li>
                        <li>포트메리온</li>
                        <li>프라다</li>
                        <li>프라이데이 미드나잇</li>
                        <li>핏플랍</li>
                        <li>핸즈인더포켓</li>
                        <li>헤지스</li>
                        <li>전체 브랜드 보기<i className="fa-solid fa-chevron-right" style={{color: "#000000"}}></i></li>
                    </ul>
                </div>
        </div>
    )
}

export default BpopupList;